import * as React from "react";
import { ChevronDown, Edit, Share } from "lucide-react";
import { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import { useToggle } from "react-use";
import { SnapshotCollectionShareModal } from "@/modules/snapshots/modals/snapshotCollectionShareModal";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { UpdateCollectionModal } from "@/modules/snapshots/modals/updateCollectionModal";

interface Props {
  snapshotCollection: SnapshotCollection;
}

export const SnapshotCollectionsRowMenu: React.FC<Props> = ({ snapshotCollection }) => {
  const [isShareOpen, toggleIsShareOpen] = useToggle(false);
  const [isRenameOpen, toggleIsRenameOpen] = useToggle(false);

  const handleClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className="flex items-center gap-2">
      {isShareOpen && (
        <SnapshotCollectionShareModal
          setIsOpen={toggleIsShareOpen}
          isOpen={isShareOpen}
          snapshotCollection={snapshotCollection}
        />
      )}
      {isRenameOpen && (
        <UpdateCollectionModal
          snapshotCollection={snapshotCollection}
          isOpen={isRenameOpen}
          setIsOpen={toggleIsRenameOpen}
        />
      )}
      {snapshotCollection.name}
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="empty" className="h-8 w-8 p-0" onClick={handleClick}>
            <ChevronDown size={16} className="text-desert-sand-500" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={toggleIsShareOpen} className="cursor-pointer">
            <Share className="mr-2 h-4 w-4" />
            Share
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={toggleIsRenameOpen} className="cursor-pointer">
            <Edit className="mr-2 h-4 w-4" />
            Rename
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
